import { Aux } from '../AuxillaryServices';
import { isDevModeEnabled } from '../../Utility/Environment';
import { NamedEvent } from '../logNamedEvent';
import { ILogMechanism } from '../../Logging/ILogMechanism';
import { LogLevel } from '../../Logging/LogLevel';
import { Nullish } from '../../Utility/Nullish';

export abstract class Log {
    static Mechanism: ILogMechanism[] = [];

    /**
     * Logs a named event. Named events are those which have a code. Named events
     * are always related to the server. Named events should generally have a data
     * payload.
     * @param code - Code for the named event
     * @param message - Human readable description of the event
     * @param source - the source of the message
     * @param data - data payload
     */
    static NamedEvent = NamedEvent;

    /**
     * Log message to an array of mechanisms (e.g. Console, IndexedDB, API, etc.)
     * @param level - Log level
     * @param message - Arbitrary message
     * @param code - @see {@link REACH.Application.GetLoggingCode}
     * @param source - Log origin [file]:[line]:[column] (e.g. 'ReachAPI.display.js:34:21')
     * @param data - Arbitrary data
     */
    static LogMessage(
        level: LogLevel,
        message: string,
        code: string | Nullish = undefined,
        source = 'unknown',
        data?: unknown
    ): void {
        Log.Mechanism.forEach(function (currentMechanism) {
            currentMechanism.LogMessage(level, message, code, source, data);
        });
    }

    static Debug(message: string, code?: string | Nullish, source?: string, data?: unknown): void {
        if (isDevModeEnabled()) {
            Log.LogMessage(LogLevel.DEBUG, message, code, source, data);
        }
    }

    static Info(message: string, code?: string | Nullish, source?: string, data?: unknown): void {
        Log.LogMessage(LogLevel.INFO, message, code, source, data);
    }

    static Notice(message: string, code?: string | Nullish, source?: string, data?: unknown): void {
        Log.LogMessage(LogLevel.INFO, message, code, source, data);
    }

    static Warning(
        message: string,
        code?: string | Nullish,
        source?: string,
        data?: unknown
    ): void {
        Log.LogMessage(LogLevel.WARNING, message, code, source, data);
    }

    static Error(message: string, code?: string | Nullish, source?: string, data?: unknown): void {
        Log.LogMessage(LogLevel.ERROR, message, code, source, data);
    }

    static Critical(
        message: string,
        code?: string | Nullish,
        source?: string,
        data?: unknown
    ): void {
        Log.LogMessage(LogLevel.CRITICAL, message, code, source, data);
    }

    //todo: use Aux hook enum
    static onServiceDiscovered(event: string): void {
        switch (event) {
            case 'Initialize': {
                Aux.RegisterService('Log', Log);

                break;
            }
        }
    }
}
